import cookies from "vue-cookies";
import config from "@/config";

export default {
  state: {
    title: "",
    env_mode: cookies.get(config.const.KEY_ENV_MODE),
    appKey: cookies.get(config.const.KEY_APP_KEY),
    appKeyName: "",
    appContact: "",
    txId: cookies.get(config.const.KEY_TX_ID),
    platformType: {
      win: false,
      wx: false,
      Android: false,
      iOS: false,
    },
    positionFlag: false,
    // 添加红点数字管理
    orderPoolCount: 0, // 当前用户尚未报价的订单池订单数
    bidOrderCount: 0, // 当前用户竞价中订单数
    pendingConfirmCount: 0, // 待上报订单数
  },
  getters: {
    env_mode(state) {
      return state.env_mode;
    },
    appKey(state) {
      return state.appKey ? state.appKey : config.defaultAppKey;
    },
    appKeyName(state) {
      return state.appKeyName;
    },
    appContact(state) {
      return state.appContact;
    },
    txId(state) {
      return state.txId || void 0;
    },
    platform(state) {
      let platform = Object.keys(state.platformType).filter(
        (key) => state.platformType[key] === true
      );
      return platform && platform.length > 0 ? platform[0] : void 0;
    },
    // 添加红点数字的getter
    orderPoolCount(state) {
      return state.orderPoolCount;
    },
    bidOrderCount(state) {
      return state.bidOrderCount;
    },
    pendingConfirmCount(state) {
      return state.pendingConfirmCount;
    },
  },
  mutations: {
    setEnvMode(state, env_mode) {
      state.env_mode = env_mode;
      env_mode
        ? cookies.set(config.const.KEY_ENV_MODE, env_mode, "0")
        : cookies.remove(config.const.KEY_ENV_MODE);
    },
    setTitle(state, title) {
      state.title = title;
    },
    setAppKey(state, appKey) {
      state.appKey = appKey;
      appKey
        ? cookies.set(config.const.KEY_APP_KEY, appKey, "0")
        : cookies.remove(config.const.KEY_APP_KEY);
    },
    setAppKeyName(state, appKeyName) {
      state.appKeyName = appKeyName;
    },
    setAppContact(state, appContact) {
      state.appContact = appContact;
    },
    setTxId(state, txId) {
      state.txId = txId;
      cookies.set(config.const.KEY_TX_ID, txId, "0");
    },
    setPlatformType(state, platform) {
      state.platformType[platform] = true;
    },
    // 添加红点数字的mutations
    setOrderPoolCount(state, count) {
      state.orderPoolCount = count;
    },
    setBidOrderCount(state, count) {
      state.bidOrderCount = count;
    },
    setPendingConfirmCount(state, count) {
      state.pendingConfirmCount = count;
    },
  },
};
